import {Component, OnInit, AfterViewInit, ElementRef} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {IClientModel} from '../../models/clients/clients.model';

import {DebtsModel, TimelineModel} from '../../models/debts/debts.model';
import {DebtsService} from '../../models/debts/debts.service';
import {ClientsService} from '../../models/clients/clients.service';
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {ApplicationUser} from "../../services/ApplicationUser";

declare var $: JQueryStatic | any;

@Component({
    selector: 'statements',
    templateUrl: 'statements.template.html',
    styleUrls: ['statements.component.css']
})

export class StatementsComponent implements OnInit, AfterViewInit {

    public debtId : number;
    public clientId: number;

    public client = <IClientModel> {};
    public debt = new DebtsModel();

    public timeline = [];
    public canEdit: boolean = true;

    public editModeEnabled = {};

    timelineFilter: any = null;

    hasTimelineFilter: any = true;

    constructor(
        private route: ActivatedRoute,
        private toasterService: ToasterService,
        public debtsService: DebtsService,
        public clientsService: ClientsService,
        public el: ElementRef
    ) {

    }

    ngOnInit() {
        this.debtId = this.route.snapshot.params['debt_id'];

        /*
        let searchStr: any = '';
        for (let i in this.route.snapshot.queryParams) {
            if (! this.route.snapshot.queryParams.hasOwnProperty(i)) continue;
            if (searchStr) searchStr += '&';
            else searchStr = '?';
            searchStr += '' + i + '=' + this.route.snapshot.queryParams[i];
        }
        if (searchStr) {
            let _a: any = document.createElement('a');
            _a.href = '/' + searchStr;
            let url: any = new URL(_a);

            let _entries: any = url.searchParams.entries();
            do {
                let entrie: any = _entries.next();
                if (entrie.done) break;
                if (! this.timelineFilter) this.timelineFilter = {};
                this.timelineFilter[entrie.value[0]] = entrie.value[1];
            } while (true);
        }
        */

        let url: any = new URL(location.href);

        let _entries: any = url.searchParams.entries();
        let hasFilter = false;
        do {
            let entrie: any = _entries.next();
            if (entrie.done) break;
            if (! this.timelineFilter) this.timelineFilter = {};
            this.timelineFilter[entrie.value[0]] = entrie.value[1];
            if (entrie.value[0] === 'from' || entrie.value[0] === 'to')
                hasFilter = true;
        } while (true);
        this.hasTimelineFilter = hasFilter;

        this.loadData();
    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================


    loadData() {


        this.debtsService.getTimelineForStatements(this.debtId)
            .subscribe((res) => {
                /*
                let tl = [];
                this.timeline = [];
                let sum = 0;
                for (let item of res.data as any) {
                    if (item.type == 'plus') {
                        this.timeline.push(item);
                        sum += item.true_amount * 1;
                    } else tl.push(item);
                }
                for (let item of tl) {
                    this.timeline.push(item);
                }

                for (let item of this.timeline) {
                    if (item.type != 'plus') continue;
                    item._new_repaid = sum;
                    sum -= item.true_amount * 1;
                }
                */
                this.timeline = [];
                let sum = 0;
                for (let item of res.data as any) {
                    if (item.reason) {
                        if (item.reason == 'funded') item.reason = 'Funded';
                        else if (item.reason == 'advance size') continue;
                    }

                    if (item.type == 'plus') {
                        this.timeline.push(item);
                        sum += item.true_amount * 1;
                    } else {
                        this.timeline.push(item);
                    }
                }

                for (let item of this.timeline) {
                    if (item.type != 'plus') continue;
                    item._new_repaid = sum;
                    sum -= item.true_amount * 1;
                }

                //this.timeline = this.timeline.reverse();

            });

        this.debtsService.getOne(this.debtId)
            .subscribe((res) => {
                this.debt = res.data;

                this.clientsService.getOne(this.debt.client_id)
                    .subscribe((res) => {
                        this.client = res.data;
                    });

            });
    }


    // ===========================================================
    // Actions
    // ===========================================================


    public close() {

    }

    public toggleEditButton(event) {
        $(event.target, this.el.nativeElement).find(".reasonEdit").toggle();
    }

    public activateEditMode(event) {
        $(event.target, this.el.nativeElement).parent().hide().next().show();
    }

    public cancelEditMode(event) {
        var val = $(event.target, this.el.nativeElement).parents(".reason").find(".reasonText").html();
        $(event.target, this.el.nativeElement).parents(".reasonInputs").find("input").val(val);
        $(event.target, this.el.nativeElement).parents(".reasonInputs").hide().parents(".reason").find(".reasonPlain").show();
    }

    public save(event, transaction) {
        var val = $(event.target, this.el.nativeElement).parents(".reasonInputs").find("input").val();
        $(event.target, this.el.nativeElement).parents(".reason").find(".reasonText").html(val);
        $(event.target, this.el.nativeElement).parents(".reasonInputs").hide().parents(".reason").find(".reasonPlain").show();

        this.debtsService.updateStatementReason(transaction.table, transaction.id, {'reason': val})
            .subscribe((res) => {
                console.log(res);
        });

    }

    get jsWin() {
        return window;
    }

    inTimelineFilter(date: any): any {
        if (! this.timelineFilter) return true;
        try {
            let d: any = new Date('' + date + ' 00:00');
            if (! isFinite(d)) return false;
            if (this.timelineFilter['from']) {
                let t0: any = new Date(this.timelineFilter['from'] * 1);
                if (! isFinite(t0)) return false;
                if (d < t0) return false;
            }
            if (this.timelineFilter['to']) {
                let t1: any = new Date(this.timelineFilter['to'] * 1);
                if (! isFinite(t1)) return false;
                if (d > t1) return false;
            }
        } catch (e) {
            return false;
        }
        return true;
    }

    printPDF() {
        let user = ApplicationUser.getInstance();

        let url = '/api/v1/debts/pdf-statement?' +
            'debt_id=' + (this.debtId * 1) +
            '&Authorization=' + user.getAccessToken();
        try {
            if (this.timelineFilter['from']) {
                let t0: any = new Date(this.timelineFilter['from'] * 1);
                if (isFinite(t0)) {
                    url += '&from=' + t0.getFullYear() + '-' + 
                        (t0.getMonth() + 1) + '-' + t0.getDate();
                }
            }
        } catch (e) {}
        try {
            if (this.timelineFilter['to']) {
                let t1: any = new Date(this.timelineFilter['to'] * 1);
                if (isFinite(t1)) {
                    url += '&to=' + t1.getFullYear() + '-' + 
                        (t1.getMonth() + 1) + '-' + t1.getDate();
                }
            }
        } catch (e) {}
        window.open(url, '_self');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/statements/statements.component.ts